import type { ColumnDef } from '@tanstack/vue-table'
import { createBaseColumns, type UserTableActions } from './baseColumns'
import { createDateColumn } from './dateColumns'
import BaseButton from '~/components/BaseButton.vue'
import RefreshIcon from '~/components/RefreshIcon.vue'

export const createDeactivatedUsersColumns = (
  actions?: UserTableActions,
): ColumnDef<ManageUserTableRow>[] => {
  const baseColumns = createBaseColumns()
  const dateColumns = [
    createDateColumn('deactivated_at', 'deactivated_at', 'date deactivated'),
  ]

  const actionsColumn: ColumnDef<ManageUserTableRow> = {
    id: 'actions',
    size: 80,
    header: () => h('span', { class: 'capitalize text-sm text-slate-800 font-semibold' }, 'actions'),
    cell: ({ row }) => {
      const tooltipClasses = 'absolute hidden group-hover:block bottom-full left-1/2 transform -translate-x-1/2 px-2 py-1 bg-zuno-primary-2 text-white text-xs rounded whitespace-nowrap mb-1 z-10'

      const handleReactivate = () => {
        actions?.onReactivate?.(row.original)
      }

      return h('div', { class: 'flex' }, [
        h('div', {
          class: 'relative group',
        }, [
          h(BaseButton, {
            variant: 'text',
            onClick: handleReactivate,
          }, () => h(RefreshIcon)),
          h('div', {
            class: tooltipClasses,
          }, 'Reactivate'),
        ]),
      ])
    },
  }

  return [
    ...baseColumns,
    ...dateColumns,
    actionsColumn,
  ]
}
